import React, {useEffect, useState, Suspense} from "react";
import { Dashboard } from "@/components/Dashboard";
import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs} from 'antd';
import "./AnalyticsDashboardExport.css";
import MunicipalitySearch from "../MunicipalitySearch";
import StandType from "../StandType";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { DashboardWidget } from "../DashboardWidget";
import { useHistory } from "react-router-dom";
import { authenticationService } from "../../services";
import Roles from "../Permission/Roles";
import { config } from "../../config";
import dayjs from "dayjs";
import MunicipalitySearchAnalytics from "../MunicipalitySearchAnalytics";
const { TabPane } = Tabs;

const testWidget=[
   
    

]

const SupplyAndDemandWidgets = [

    {
        id: 'DailyDemandPerHourGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/DailyDemandPerHourGraph", // relative to src
        layout: { i: 'DailyDemandPerHourGraph', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
    },

    {
        id: 'NumberOfTypesOfStands', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'NumberOfTypesOfStands', x: 0, y: 6, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih parkirališnih površina prema tipu stalka",
        answer_name:"bicycle_stand_type",
        survey_id:0,
    },
    {
        id: 'ParkingSpaceStandsByAccordanceToRulebook', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AccordanceToRulebookGraph",
        layout: { i: 'ParkingSpaceStandsByAccordanceToRulebook', x: 0, y: 22, w: 12, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-space-stands-by-accordance-to-rulebook',	
        answer_title:'Udio identificiranih parkirališnih površina s obzirom na status usklađenosti s Pravilnikom',
    }, 

    {
        id: 'BicycleStandsByType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'BicycleStandsByType', x: 0, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-vehicle-type',
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema tipu',
    },

    {
        id: 'CoverTypePerParkingSpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'CoverTypePerParkingSpace', x: 6, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih parkirališnih površina prema statusu natkrivenosti",
        answer_name:"cover_type",
        survey_id:0,
    },
    

    {
        id: 'ParkingSpacesByTypeGraph', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph",
        layout: { i: 'ParkingSpacesByTypeGraph', x: 0, y: 6, w: 12, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:['capacity_value_theoretical','capacity_value'],	
        answer_title:'Udio identificiranog kapaciteta prema tipu',
        stacked_horizontal_chart_y_axis:['Teorijski','Operativni'],
        offset_x:120,
        offset_y:visualViewport.width>1000&&-120||visualViewport.width<580&&-visualViewport.width/13||-visualViewport.width/10,
        max_width:300,
    },

    {
        id: 'CoverTypePerSingularParkingSpot', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'CoverTypePerSingularParkingSpot', x: 0, y: 9, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-cover-type-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu natkrivenosti',
    },

    {
        id: 'CoverTypePerCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'CoverTypePerCapacity', x: 6, y: 9, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-cover-type-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu natkrivenosti',
    },

    {
        id: 'BicycleFastenedToGround', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleFastenedToGround', x: 0, y: 12, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-status-of-fastening-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu učvršćivanja za tlo/objekt',
    },

    {
        id: 'BicycleFastenedToGroundCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleFastenedToGroundCapacity', x: 6, y: 12, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-status-of-fastening-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu učvršćivanja za tlo/objekt',
    },

    {
        id: 'BicycleStandsBoundToPlace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsBoundToPlace', x: 0, y: 15, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-bicycle-way-of-binding',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu vezivanja bicikla za okvir',
    },

    {
        id: 'BicycleStandsBoundToPlaceCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsBoundToPlaceCapacity', x: 6, y: 15, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-bicycle-way-of-binding-by-type-and-spaces',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu vezivanja bicikla za okvir',
    },
    

    {
        id: 'BicycleStandsInAccordanceWithRulebook', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsInAccordanceWithRulebook', x: 0, y: 18, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-recommendation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio stalaka usklađenih s Pravilnikom o biciklističkoj infrastrukturi',
    },

    {
        id: 'BicycleStandsInAccordanceWithRulebookCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsInAccordanceWithRulebookCapacity', x: 6, y: 18, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-recommendation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta usklađenog s Pravilnikom o biciklističkoj infrastrukturi',
    },

    {
        id: 'FunctionalityStatusResident', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'FunctionalityStatusResident', x: 0, y: 21, w: 6, h: 3, isDraggable: true, isBounded: true },      
        analytic_url:'get-parking-stands-by-status-of-functionality-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Status adekvatnosti identificiranih stalaka s obzirom na funkcionalnost',
    },

    {
        id: 'FunctionalityStatusResidentCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'FunctionalityStatusResidentCapacity', x: 6, y: 21, w: 6, h: 3, isDraggable: true, isBounded: true },      
        analytic_url:'get-parking-capacity-by-status-of-functionality-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Status adekvatnosti identificiranog kapaciteta s obzirom na funkcionalnost',
    },

    {
        id: 'PreservationAdequacyResident', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'PreservationAdequacyResident', x: 0, y: 24, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-status-of-preservation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Status adekvatnosti identificiranih stalaka s obzirom na stanje očuvanosti',
    }, 

    {
        id: 'PreservationAdequacyResidentCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'PreservationAdequacyResidentCapacity', x: 6, y: 24, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-status-of-preservation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Status adekvatnosti identificiranog kapaciteta stalaka s obzirom na stanje očuvanosti',
    }, 

    {
        id: 'BicycleStandsByPurpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsByPurpose', x: 0, y: 27, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-purpose-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
    },

    {
        id: 'BicycleStandsByPurposeCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph",
        layout: { i:'BicycleStandsByPurposeCapacity', x: 6, y: 27, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-purpose-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:['capacity_value_theoretical','capacity_value'],	
        answer_title:'Udio identificiranih kapaciteta stalaka prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
        stacked_horizontal_chart_y_axis:['Teorijski','Operativni'],
        offset_x:120,
        offset_y:visualViewport.width>1000&&-115||visualViewport.width<580&&-visualViewport.width/13||-visualViewport.width/11,
        max_width:300,
    },
   
    {
        id: 'DemandByPurposeCombinedGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph", // relative to src
        layout: { i: 'DemandByPurposeCombinedGraph', x: 0, y: 30, w: 12, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-demand-by-purpose-combined',	
        survey_title_key:'svrha_parkiranja',	
        survey_value_key:['udio_potraznje','udio_potraznje_alt'],	
        answer_title:'Udio postojeće i alternativne(neadekvatan ili nepostojeći stalak) potražnje prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
        stacked_horizontal_chart_y_axis:['Postojeća','Alternativna'],
        offset_x:135,
        offset_y:visualViewport.width>1000&&-110||visualViewport.width<580&&-visualViewport.width/13||-visualViewport.width/12,
        max_width:300,
    },

    
{
    id: 'DemandByStandTypeGraph',
    visible: true,
    component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
    layout: { i: 'DemandByStandTypeGraph', x: 0, y: 30, w: 6, h: 3, isDraggable: true, isBounded: true },
    analytic_url:'get-demand-by-stand-type',	
    survey_title_key:'tip_stalka',	
    survey_value_key:'udio_potraznje',	
    answer_title:'Udio postojećih stalaka prema tipu pri unosu potražnje',
},


{
    id: 'ReasonsForNotUsingBicycleStandGraph',
    visible: true,
    component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
    layout: { i: 'ReasonsForNotUsingBicycleStandGraph', x: 6, y: 30, w: 6, h: 3, isDraggable: true, isBounded: true },
    analytic_url:'get-reasons-for-not-using-bicycle-stand',	
    survey_title_key:'razlozi_ne_koristenja_stalka',	
    survey_value_key:'broj_odgovora',	
    answer_title:'Udio prijavljenih razloga ne korištenja postojećih stalaka pri unosu potražnje',
},

{
    id: 'ImportantImprovementElementSupply', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'ImportantImprovementElementSupply', x: 0, y: 33, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Udio najvažnijih elemenata unaprijeđenja pri unosu ponude",
    answer_name:"important_improvement_element",
    survey_id:0,  
},

{
    id: 'ImportantImprovementElementDemand', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'ImportantImprovementElementDemand', x: 6, y: 33, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Udio najvažnijih elemenata unaprijeđenja pri unosu potražnje",
    answer_name:"important_improvement_element_demand",
    survey_id:0,  
},

    
   
];
 

const ResidentWidgets = [
    

    {
       id: 'JlsPickBigResident', 
       visible: true,
       component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticJLSBarGraph",
       layout: { i: 'JlsPickBigResident', x: 0, y: 0, w: 12, h: 3, isDraggable: true, isBounded: true },
       answer_title:"Prostorni raspored prikupljenog uzorka",
       answer_name:"jls_pick",
       survey_id:6,
   }, 
   {
       id: 'ageBigResident', 
       visible: true,
       component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticAgeDonutGraph",
       layout: { i: 'ageBigResident', x: 0, y: 3, w: 12, h: 3, isDraggable: true, isBounded: true },
       answer_title:"Uzorak prema dobnim skupinama",
       answer_name:"age",
       survey_id:6,
   },
   {
    id: 'WorkActivityBigResident', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'WorkActivityBigResident', x: 0, y: 6, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Uzorak prema radnoj aktivnosti ispitanika",
    answer_name:"work_activity",
    survey_id:6,
}, 
{
    id: 'AvailableBicycle', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'AvailableBicycle', x: 0, y: 9, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Status ispitanika s obzirom na dostupnost bicikla za svakodnevno korištenje",
    answer_name:"available_bicycle",
    survey_id:6,
}, 
{
    id: 'UnavailableBicycleReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'UnavailableBicycleReason', x: 0, y: 12, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi nedostupnosti bicikla za svakodnevno korištenje",
    answer_name:"unavailable_bicycle_reason",
    survey_id:6,
},

{
    id: 'BicycleUsagePurposeYesOrNo', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/BicycleUsagePurpose",
    layout: { i: 'BicycleUsagePurposeYesOrNo', x: 0, y: 15, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Struktura aktivnosti korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_purpose_yes_or_no",
    survey_id:6,
},   
{
    id: 'BicycleUsagePurposeOnlyYes', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/BicycleUsagePurpose",
    layout: { i: 'BicycleUsagePurposeOnlyYes', x: 0, y:18, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešća svrha korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_purpose_only_yes",
    survey_id:6,
},   
{
    id: 'BicycleUsageFrequency', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageFrequency', x: 0, y: 21, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_frequency",
    survey_id:6,
}, 
{
    id: 'BicycleUsageFrequencyByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageFrequencyByPurpose-purpose', x: 0, y: 24, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla prema svrsi putovanja",  
    analytic_url:'get-bicycle-usage-frequency-by-purpose',  
    filter_key:'purpose',
    mapped_key:'frequency',    
}, 

{
    id: 'BicycleUsageFrequencyByPurpose-frequency', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageFrequencyByPurpose-frequency', x: 0, y:27, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla prema svrsi putovanja", 
    analytic_url:'get-bicycle-usage-frequency-by-purpose',
    filter_key:'frequency',
    mapped_key:'purpose',
    filter_elements:'bicycle_frequency'
}, 

{
    id: 'BicycleUsageReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageReason', x: 0, y: 30, w: 16, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi motivacije korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_reason",
    survey_id:6,
},    


{
    id: 'BicycleUsageChallenge', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageChallenge', x: 0, y: 33, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći izazovi pri korištenju bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_challenge",
    survey_id:6,
}, 
        
{
    id: 'BicycleUsageParkingPurpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingPurpose', x: 0, y:36, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla",
    answer_name:"bicycle_usage_parking_purpose",
    survey_id:6,
}, 
{
    id: 'BicycleUsageParkingPurposeByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingPurposeByPurpose-purpose', x: 0, y:39, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-purpose-by-purpose',
    mapped_key:'parking_purpose',
    filter_key:'purpose',
}, 
{
    id: 'BicycleUsageParkingPurposeByPurpose-parking_purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingPurposeByPurpose-parking_purpose', x: 0, y:42, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-purpose-by-purpose',
    mapped_key:'purpose',
    filter_key:'parking_purpose',
    filter_elements:'bicycle_parking_purpose'
}, 
{
    id: 'BicycleUsageParkingStandType', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingStandType', x: 0, y: 45, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala",
    answer_name:"bicycle_usage_parking_stand_type",
    survey_id:6,
},    
{
    id: 'BicycleUsageParkingStandTypeByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingStandTypeByPurpose-purpose', x: 0, y: 48, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-stand-type-by-purpose',
    mapped_key:'parking_stand_type',
    filter_key:'purpose',
},       
{
    id: 'BicycleUsageParkingStandTypeByPurpose-stand_type', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingStandTypeByPurpose-stand_type', x: 0, y: 51, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-stand-type-by-purpose',
    mapped_key:'purpose',
    filter_key:'parking_stand_type',
    filter_elements:'bicycle_stand_type'
}, 
{
    id: 'BicycleUsageParkingInadequacyReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingInadequacyReason', x: 0, y: 54, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći elementi neadekvatnosti dostupnih stalaka za odlaganje bicikala",
    answer_name:"bicycle_usage_parking_inadequacy_reason",
    survey_id:6,
},         
{
    id: 'BicycleUsageParkingOptimalTypeOfStand', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingOptimalTypeOfStand', x: 0, y: 57, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Optimalan tip stalka prema izboru biciklista",
    answer_name:"bicycle_usage_parking_optimal_type_of_stand",
    survey_id:6,
},          
     
 
{
    id: 'BicycleNonUsageReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleNonUsageReason', x:0, y: 60, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi nekorištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_non_usage_reason",
    survey_id:6,
},          
  
{
    id: 'ReasonsMotivationToUseBicycle', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'ReasonsMotivationToUseBicycle', x: 0, y: 63, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najvažniji razlozi motivacije korištenja bicikla/sustava javnih bicikala ",
    answer_name:"reasons_motivation_to_use_bicycle",
    survey_id:6,
},  

    {
        id: 'ScooterUsagePurposeYesOrNo', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/ScooterUsagePurpose",
        layout: { i: 'ScooterUsagePurposeYesOrNo', x: 0, y: 66, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Struktura aktivnosti korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_purpose_yes_or_no",
    },   
    {
        id: 'ScooterUsagePurposeOnlyYes', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/ScooterUsagePurpose",
        layout: { i: 'ScooterUsagePurposeOnlyYes', x: 0, y: 69, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešća svrha korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_purpose_only_yes",
    },   

    {
        id: 'ScooterUsageFrequency', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageFrequency', x: 0, y:72, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_frequency",
        survey_id:6,
    }, 
    {
        id: 'ScooterUsageFrequency-purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageFrequency-purpose', x: 0, y:75, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila prema svrsi putovanja",
        analytic_url:'get-scooter-usage-frequency-by-purpose',
        mapped_key:'frequency',
        filter_key:'purpose',
    }, 
    {
        id: 'ScooterUsageFrequency-frequency', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageFrequency-frequency', x: 0, y:78, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila prema svrsi putovanja",
        analytic_url:'get-scooter-usage-frequency-by-purpose',
        mapped_key:'purpose',
        filter_key:'frequency',
        filter_elements:'scooter_frequency'
    }, 
    {
        id: 'ScooterUsageReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageReason', x: 0, y: 81, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći razlozi motivacije korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_reason",
        survey_id:6,
    }, 
    {
        id: 'ScooterUsageChallenge', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageChallenge', x: 0, y: 84, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći izazovi pri korištenju romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_challenge",
        survey_id:6,
    },  
    {
        id: 'ScooterUsageParkingTypeReplacement', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageParkingTypeReplacement', x: 0, y: 87, w: 12, h: 3, isDraggable: true, isBounded: true },
        //ovo nije dobro
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila",
        answer_name:"scooter_usage_parking_type_replacement",
        survey_id:6,
    }, 
    
    {
        id: 'ScooterUsageParkingTypeReplacement-purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageParkingTypeReplacement-purpose', x: 0, y: 90, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila po pojedinim svrhama",
        analytic_url:'get-scooter-usage-parking-purpose-by-purpose',
        mapped_key:'parking_purpose',
        filter_key:'purpose',
    },  
    {
        id: 'ScooterUsageParkingTypeReplacement-parking_purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageParkingTypeReplacement-stand_type', x: 0, y: 93, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila po pojedinim svrhama",
        analytic_url:'get-scooter-usage-parking-purpose-by-purpose',
        mapped_key:'purpose',
        filter_key:'parking_purpose',
        filter_elements:'scooter_parking_purpose'
    },  

    {
        id: 'ScooterUsageParkingInadequacyReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageParkingInadequacyReason', x: 0, y: 96, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći elementi neadekvatnosti dostupnih stalaka za odlaganje romobila",
        answer_name:"scooter_usage_parking_inadequacy_reason",
        survey_id:6,
    },     
    {
        id: 'BicycleUsageParkingTypeReplacement', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleUsageParkingTypeReplacement', x: 0, y: 99, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Optimalan tip stalka za bickle kao kvalitetna alternativa stalku za romobile",
        answer_name:"bicycle_usage_parking_type_replacement",
        survey_id:6,
    },    
    {
        id: 'ScooterNonUsageReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterNonUsageReason', x: 0, y: 102, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći razlozi nekorištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_non_usage_reason",
        survey_id:6,
    },     

    {
        id: 'RatingJls', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'RatingJls', x: 0, y: 105, w:12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Struktura ocjena elemenata postojećeg stanja",
        answer_name:"rating_jls",
        survey_id:6,
        offset_x:visualViewport.width>600&&350||295,
        offset_y:visualViewport.width<1000&&-23||-26,
        max_width:visualViewport.width>600&&600||330,
    },
 
    {
        id: 'RateAgreeingWithClaim', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'RateAgreeingWithClaim', x: 0, y: 108, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Struktura stavova",
        answer_name:"rate_agreeing_with_claim",
        survey_id:6,
        offset_x:visualViewport.width>1000&&830||visualViewport.width-170,
        offset_y:visualViewport.width<1000&&-53||-65,
        max_width:visualViewport.width>1000&&900||visualViewport.width-100,
    },
      {
       id: 'CommentsWidget', 
         visible: true,
      component: "components/Widgets/CommentsWidget",
        layout: { i: 'CommentsWidget', x: 0, y: 54, w: 12, h: 4, isDraggable: true, isBounded: true },
      answer_title:"Komentari građani",
        answer_name:"user_comment",
        survey_id:6,
     },  
   

];

const JlsWidgets = [
     {/*
        id: 'JlsPickBigJls', 
        visible: true,
        component: "components/Widgets/SurveyAnsweredWidgetJLS",
        layout: { i: 'JlsPickBigJls', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Gradovi i općine čiji su predstavnici ispunili web upitnik za jedinice lokalne samouprave",
        answer_name:"jls_pick",
        survey_id:1,
*/ }, 

    {
        id: 'RulebookKnowledgeBigJls', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookKnowledgeBigJls', x: 6, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na poznavanje sadržaja Pravilnika o biciklističkoj infrastrukturi (NN28/2016)",
        answer_name:"rulebook_knowledge",
        survey_id:1,
    },
    {
        id: 'RulebookDeadlineKnowledge', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookDeadlineKnowledge', x: 0, y:3, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na upoznatost s vremenskim rokovima za usklađivanje postojeće infrastrukture definirane Pravilnikom o biciklističkoj infrastrukturi (NN28/2016)",
        answer_name:"rulebook_deadline_knowledge",
        survey_id:1,
    }, 
    {
        id: 'RulebookImplementedElements', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookImplementedElements', x: 6, y:3, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Udio elemenata postojećeg prometnog sustava koje su (sukladno navodima u web upitniku) JLS-ovi uskladili s Pravilnikom o biciklističkoj infrastrukturi u Pravilnikom definiranim rokovima",
        answer_name:"rulebook_implemented_elements",
        survey_id:1,
    }, 

    {
        id: 'ElaborationCreationStatus', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ElaborationCreationStatus', x: 0, y:6, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu izrade prometnog elaborata u funkciji analize, pripreme i provedbe unaprjeđenja postojeće biciklističke infrastrukture",
        answer_name:"elaboration_creation_status",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverage', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverage', x: 6, y:6, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu vođenja evidencije prostorne pokrivenosti biciklističkom infrastrukturom",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverageStorageType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverageStorageType', x: 0, y:9, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći način kojim JLS-ovi vode evidenciju prostorne pokrivenosti biciklistčkom infrastrukturom",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage_storage_type",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverageAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverageAvailability', x: 6, y:9, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Status javne dostupnosti evidencije prostorne pokrivenosti biciklističkom infrastrukturom koju vode JLS-ovi",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage_availability",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacity', x: 0, y:12, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu vođenja evidencije prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureCapacityStorageType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacityStorageType', x: 6, y:12, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći način kojim JLS-ovi vode evidenciju prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity_storage_type",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureCapacityAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacityAvailability', x: 0, y:15, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Status javne dostupnosti evidencije prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity_availability",
        survey_id:1,
    }, 
    {
        id: 'ImplementedBicycleTracks', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ImplementedBicycleTracks', x: 6, y:15, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći tip implementiranih biciklističkih prometnica prema evidenciji JLS-ova",
        answer_name:"implemented_bicycle_tracks",
        survey_id:1,
    }, 

    {
        id: 'BicycleSystemUpgradeDifficulties', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleSystemUpgradeDifficulties', x: 0, y:18, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
        answer_title:"Udio najčešćih izazova pri provedbi unaprjeđenja/razvoja biciklističkog sustava",
        answer_name:"bicycle_system_upgrade_difficulties",
        survey_id:1,
    }, 
    {
        id: 'BicycleInfrastructureImportance', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleInfrastructureImportance', x: 6, y:18, w: 6, h: visualViewport.width>600&&4||4, isDraggable: true, isBounded: true },
        answer_title:"Razina važnosti implementacije biciklističke infrastrukture u funkciji razvoja održive mobilnosti ",
        answer_name:"bicycle_infrastructure_importance",
        survey_id:1,
    },
    {
        id: 'OptimalCapacityImplementationImportance', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'OptimalCapacityImplementationImportance', x: 0, y:21, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Razina važnosti implementacije optimalnog broja parkirališnih kapaciteta za bicikle u funkciji razvoja kvalitetnog biciklističkog sustava",
        answer_name:"optimal_capacity_implementation_importance",
        survey_id:1,
    }, 
    {
        id: 'ParkingCapacityAdditionLastYear', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ParkingCapacityAdditionLastYear', x: 6, y:21, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu implementacije novih parkirališnih kapaciteta za bicikle tijekom 2022. godine",
        answer_name:"parking_capacity_addition_last_year",
        survey_id:1,
    },

    {
        id: 'BiggestChallengeInImplementationOfOptimalParkingSystem', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BiggestChallengeInImplementationOfOptimalParkingSystem', x: 0, y:24, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
        answer_title:"Udio najvećih izazova pri dostizanju optimalanog razvoja sustava parkirališne ponude za bicikle i romobile",
        answer_name:"biggest_challenge_in_implementation_of_optimal_parking_system",
        survey_id:1,
    }, 
    {
        id: 'ExistanceOfParkingCapacityForRomobile', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ExistanceOfParkingCapacityForRomobile', x: 6, y:24, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na dostupnost parkirališnih kapaciteta za romobile",
        answer_name:"existance_of_parking_capacity_for_romobile",
        survey_id:1,
    },

    {
        id: 'PublicBicycleSystem', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'PublicBicycleSystem', x: 0, y:27, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na dostupnost sustava javnih bicikala",
        answer_name:"public_bicycle_system",
        survey_id:1,
    }, 
    {
        id: 'StrategicImplementationPlanAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'StrategicImplementationPlanAvailability', x: 6, y:27, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova s obzirom status posjedovanja strateško-implementativnog plana podizanja prostorne pokrivenosti, kvalitete i kapaciteta parkirališne ponude za bicikle i romobile",
        answer_name:"strategic_implementation_plan_availability",
        survey_id:1,
    },
   
    {
        id: 'BicycleInfrastructureComplexity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'BicycleInfrastructureComplexity', x: 0, y: 30, w: 12, h: 8, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena razine kompleksnosti implementacije navedenih elemenata(stavovi predstavnika JLS-ova)",
        answer_name:"bicycle_infrastructure_complexity",
        survey_id:1,
        offset_x:visualViewport.width>1000&&550||visualViewport.width-320,
        offset_y:visualViewport.width>1000&&-14||-10,
        max_width:visualViewport.width>1000&&650||visualViewport.width-20,
    }, 
    
    
    
    {
        id: 'ParkingOfferRating', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'ParkingOfferRating', x: 0, y: 0, w: 38, h: 5, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena postojeće biciklističke parkirališne ponude navedenih elemenata(stavovi predstavnika JLS-ova)",
        answer_name:"parking_offer_rating",
        survey_id:1,
        offset_x:visualViewport.width>1000&&680||visualViewport.width-200,
        offset_y:visualViewport.width>1000&&-40||-31,
        max_width:visualViewport.width>1000&&800||visualViewport.width-100,
    }, 
   
    {
        id: 'ParkingOfferInAccordanceToBuildingTypeRating', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'ParkingOfferInAccordanceToBuildingTypeRating', x: 0, y: 0, w: 42, h: 5, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena usklađenosti postojeće parkirališne ponude s pravilnikom(stavovi predstavnika JLS-ova)",
        answer_name:"parking_offer_in_accordance_to_building_type_rating",
        survey_id:1,
        offset_x:310,
        offset_y:visualViewport.width<1000&&-visualViewport.width/40||-28,
        max_width:400,
    }, 
    {id: 'CommentsWidgetJLS', 
    visible: true,
    component: "components/Widgets/CommentsWidgetJLS",
    layout: { i: 'CommentsWidgetJLS', x: 0, y:27, w: 12, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Komentari JLS",
    answer_name:"jls_comment",
    survey_id:6,}
];



const AnalyticsDashboardExport = ({show, onClose, ...props}) => {
    const [searchParams, setSearchParams] = useState(null)
    const [isPrinting, setIsPrinting] = useState(false)
    const[activeTab,setActiveTab]= useState("identificirana ponuda i potražnja")
    const history = useHistory()

    const handlePrint = () => {
        setIsPrinting(true)
        window.print()
    }
    const clickedTab=(key)=>{      
        if(key==1){
            setActiveTab("identificirana ponuda i potražnja")
        } 
        else if (key==2)
        {
        setActiveTab("upitnik za stanovnike")
        }
        else if (key==3)
        {
        setActiveTab("upitnik za predstavnike JLS-ova")
        }
    }
    //const widgets = SupplyAndDemandWidgets.filter(w => w.visible).map(x => React.lazy(() => import(`@/${x.component}`)))

    return (
      
        
        <div className="export__content">
            <div>

            {/* {authenticationService?.currentUserValue?.details?.jlsAffiliation&&<img width='50' height='60' className='jlsCrest' src={`${config.url}/uploads/photos/jls_crest/${authenticationService?.currentUserValue?.details?.jlsAffiliation}.png`}></img>|| null} */}
            </div>
            <div className="analytics__search" style={{display:'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '0.2rem'}}>
                {authenticationService?.currentUserValue?.type == Roles.Admin && (
                    <>
                        <MunicipalitySearchAnalytics />
                        <StandType />
                    </>
                ) || null}
             
                <Button className='exportPrintButton' type="primary" style={{background: '#000', borderColor: '#000'}} onClick={handlePrint}>Ispis</Button>
            </div>          
            <Button className="ExportCloseButton" onClick={() => {
                history.push('/app/nationaldatabase');
                window.location = window.location
            }}>✕</Button>
           
        <div className="export__front-page">
            <h1>CikloParking – Projekt razvoja Nacionalne baze biciklističke parkirališne ponude i potražnje</h1>
            <p><strong>Dinamičko analitičko izvješće</strong>: {activeTab}</p>
            <p><strong>Datum</strong>: {dayjs().format('DD.MM.YYYY')}</p>
            <p><strong>Svrha izvješća</strong>: Prilog Pozivu za dodjelu sredstava financiranja biciklističke infrastrukture</p>
            {authenticationService?.currentUserValue?.details?.jlsAffiliation&&<img className='jlsCrest' src={`${config.url}/uploads/photos/jls_crest/${authenticationService?.currentUserValue?.details?.jlsAffiliation}.png`}></img>|| null}
            <p><strong>Jedinica lokalne samouprave</strong>: {authenticationService?.currentUserValue?.jls_affiliation || 'N/A'}</p>
            <p><strong>OIB</strong>: {authenticationService?.currentUserValue?.details?.oib || 'N/A'}</p>
            <p><strong>Adresa</strong>: {authenticationService?.currentUserValue?.details?.address || 'N/A'}</p>
            <p><strong>Kontakt</strong>: {authenticationService?.currentUserValue?.details?.recoveryEmail || 'N/A'}</p>
        </div>

        <Tabs defaultActiveKey="1"  onTabClick={clickedTab}>
   
        <TabPane tab="Analitika - identificirana ponuda i potražnja" key="1"
        >
            <Dashboard widgets={SupplyAndDemandWidgets} isPrinting={true} searchParams={searchParams} {...props} />
        </TabPane>
        <TabPane tab="Analitika - upitnik za stanovnike" key="2" > 
            <Dashboard widgets={ResidentWidgets} isPrinting={true} searchParams={searchParams} {...props} /> 
        </TabPane>

        <TabPane tab="Analitika - upitnik za predstavnike JLS-ova" key="3">
            <Dashboard widgets={JlsWidgets} isPrinting={true} searchParams={searchParams} {...props} />
        </TabPane>
        </Tabs>
        </div>	
        
    )
}

export default AnalyticsDashboardExport;